/* KBW flooring grid — KBW-80.
 *
 * Custom script: not part of the Maximize theme, so a theme update will
 * never overwrite it.
 *
 * Every card is already in the page, printed server-side. This only hides
 * the ones a filter has ruled out and reorders the ones a sort has asked
 * for -- no fetch, no re-render, so a crawler and a no-JS visitor both see
 * the full 25 regardless.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-kbw-fl]').forEach(initFlooringGrid);

  function initFlooringGrid(root) {
    var grid = root.querySelector('[data-kbw-fl-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kbw-fl-card]'));
    var originalOrder = cards.slice();
    var checkboxes = Array.prototype.slice.call(root.querySelectorAll('[data-kbw-fl-filter]'));
    var countEl = root.querySelector('[data-kbw-fl-count]');
    var emptyEl = root.querySelector('[data-kbw-fl-empty]');
    var resetBtn = root.querySelector('[data-kbw-fl-reset]');
    var sortSelect = root.querySelector('[data-kbw-fl-sort]');

    if (!grid || !cards.length) return;

    // --- filter groups ---------------------------------------------------------
    // One group per plank field that varies (the section prints them). Within
    // a group the ticked values are alternatives (7 mm OR 8 mm); across groups
    // every group must agree (Series 8 AND 8 mm). Several of these fields move
    // together in the data -- a series fixes its thickness, its coverage and
    // its plank count -- so after every change each option's count is worked
    // out against what is ticked in the OTHER groups, and an option that would
    // give nothing is dimmed and locked. Without that, four correlated groups
    // are four ways to walk into "No planks match".
    function facetOf(cb) {
      return cb.getAttribute('data-facet') || 'series';
    }

    function cardValue(card, facet) {
      var v = card.getAttribute('data-f-' + facet.replace(/_/g, '-'));
      if (v === null && facet === 'series') v = card.dataset.series;
      return v;
    }

    function selections() {
      var groups = {};
      checkboxes.forEach(function (cb) {
        if (!cb.checked) return;
        var facet = facetOf(cb);
        (groups[facet] = groups[facet] || []).push(cb.value);
      });
      return groups;
    }

    function passes(card, groups, skipFacet) {
      return Object.keys(groups).every(function (facet) {
        if (facet === skipFacet) return true;
        return groups[facet].indexOf(cardValue(card, facet)) !== -1;
      });
    }

    // Values arrive in the order the products were met. Where every option in
    // a group carries a number, put them in number order.
    Array.prototype.forEach.call(root.querySelectorAll('[data-kbw-fl-group]'), function (group) {
      var list = group.querySelector('[data-kbw-rail-options]') || group;
      var opts = Array.prototype.slice.call(list.querySelectorAll('.kbw-rail__check'));
      var num = function (opt) {
        var m = (opt.querySelector('input').value.match(/[\d.]+/) || [])[0];
        return m === undefined ? NaN : parseFloat(m);
      };
      if (opts.some(function (o) { return isNaN(num(o)); })) return;
      opts.sort(function (a, b) { return num(a) - num(b); }).forEach(function (o) { list.appendChild(o); });
    });

    function applyFilter() {
      var groups = selections();
      var anyTicked = Object.keys(groups).length > 0;
      var visible = 0;
      cards.forEach(function (card) {
        var show = passes(card, groups, null);
        card.hidden = !show;
        if (show) visible += 1;
      });
      checkboxes.forEach(function (cb) {
        var facet = facetOf(cb);
        var n = 0;
        cards.forEach(function (card) {
          if (cardValue(card, facet) === cb.value && passes(card, groups, facet)) n += 1;
        });
        var opt = cb.closest ? cb.closest('.kbw-rail__check') : null;
        var optCount = opt ? opt.querySelector('[data-kbw-fl-optcount]') : null;
        if (optCount) optCount.textContent = n;
        var dead = n === 0 && !cb.checked;
        cb.disabled = dead;
        if (opt) opt.classList.toggle('is-empty', dead);
      });
      if (countEl) countEl.innerHTML = '<b>' + visible + '</b> ' + (visible === 1 ? 'design' : 'designs');
      if (emptyEl) emptyEl.hidden = visible !== 0;
      if (resetBtn) resetBtn.hidden = !anyTicked;
      if (window.KbwRail) window.KbwRail.refresh(root);
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', applyFilter);
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        checkboxes.forEach(function (cb) { cb.checked = false; });
        applyFilter();
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var value = sortSelect.value;
        var sorted;
        if (value === 'thickness') {
          sorted = cards.slice().sort(function (a, b) {
            return (parseFloat(a.dataset.thickness) || 0) - (parseFloat(b.dataset.thickness) || 0);
          });
        } else if (value === 'title') {
          sorted = cards.slice().sort(function (a, b) {
            return a.dataset.title.localeCompare(b.dataset.title, undefined, { numeric: true });
          });
        } else if (value === 'newest') {
          sorted = cards.slice().sort(function (a, b) {
            return (parseInt(b.dataset.created, 10) || 0) - (parseInt(a.dataset.created, 10) || 0);
          });
        } else {
          sorted = originalOrder.slice();
        }
        sorted.forEach(function (card) { grid.appendChild(card); });
      });
    }

    // --- the rail, "Show more" and the phone drawer ---------------------------
    // KBW: assets/kbw-filter-rail.js, the site's one filter rail standard
    // (client, 2026-09-15). What is left here is this list's own filtering.

    // --- a series pre-selected from the URL ----------------------------------
    // The header's Series 7/8/10 dropdown cards each link here with
    // ?series=Series+N so the page lands already filtered to the one the
    // visitor chose -- one page, three ways in, per KBW-80. The value has to
    // match a checkbox's value exactly (it does: both come from the same
    // "Series N" label), so an unrecognised or missing param just leaves
    // every card showing, same as landing here with no query string at all.
    try {
      var preselect = new URLSearchParams(window.location.search).get('series');
      if (preselect) {
        checkboxes.forEach(function (cb) {
          if (facetOf(cb) === 'series' && cb.value === preselect) cb.checked = true;
        });
      }
    } catch (e) {
      /* URLSearchParams missing or malformed query string -- leave everything showing */
    }
    applyFilter();
  }
})();
